<template>
  <div dir="ltr" class="relative">
    <div class="is-size-7" v-if="sent_applicants">
      <p>Sent Applicants: {{ sendApplicantCounterOnly.sent_applicants }}</p>
    </div>
    <div v-if="!short_version" class="is-flex">
      <a @click="showCountOnly()" class="button is-info is-outlined">#</a>
      <div style="width: 6px;"></div>
      <router-link
        :to="{
          name: getOffersLinkRouteName,
          query: { statuses: getDefaultStatuses, ...getOffersLinkQuery, sort: getSort, is_hot_positions: 'true' }
        }"
        :target="target"
        class="button is-info is-outlined"
        >Offers</router-link
      >
    </div>
    <div class="is-flex is-justify-content-flex-start" style="margin-top: 6px;">
      <div
        @mouseleave="onMouseLeave()"
        @mouseover="onMouseOver('Purple')"
        class="white is-flex is-align-items-center is-justify-content-center"
        style="height: 19px; background-color: #872EC4; min-width: 30px; white-space: normal;"
      >
        {{ purple_count_only }}
      </div>
      <div
        @mouseleave="onMouseLeave()"
        @mouseover="onMouseOver('Green')"
        class="white is-flex is-align-items-center is-justify-content-center"
        style="height: 19px; background-color: green; min-width: 30px; white-space: normal;"
      >
        {{ green_count_only }}
      </div>
      <div
        @mouseleave="onMouseLeave()"
        @mouseover="onMouseOver('Orange')"
        class="white is-flex is-align-items-center is-justify-content-center"
        style="height: 19px; background-color: orange; min-width: 30px; white-space: normal;"
      >
        {{ orange_count_only }}
      </div>
      <div
        @mouseleave="onMouseLeave()"
        @mouseover="onMouseOver('Red')"
        class="white is-flex is-align-items-center is-justify-content-center"
        style="height: 19px; background-color: red; min-width: 30px; white-space: normal;"
      >
        {{ red_count_only }}
      </div>
      <div
        @mouseleave="onMouseLeave()"
        @mouseover="onMouseOver('DarkRed')"
        class="white is-flex is-align-items-center is-justify-content-center"
        style="height: 19px; background-color: saddlebrown; min-width: 30px; white-space: normal;"
      >
        {{ dark_red_count_only }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  props: ['payload', 'additional_data', 'eager_load', 'target', 'short_version', 'sent_applicants'],
  name: 'ghana-flag',
  data () {
    return {
      purple_count_only: '-',
      green_count_only: '-',
      orange_count_only: '-',
      red_count_only: '-',
      dark_red_count_only: '-',
      sendApplicantCounterOnly: {}
    }
  },
  async created () {
    if (this.eager_load) {
      try {
        // Wait for offer statuses to be loaded before calling API
        await this.ensureOfferStatusesLoaded()
        await this.showCountOnly()
      } catch (error) {
        console.error('Error in GhanaFlag showCountOnly:', error)
        // Ensure values are set even on error
        this.purple_count_only = 0
        this.green_count_only = 0
        this.orange_count_only = 0
        this.red_count_only = 0
        this.dark_red_count_only = 0
      }
    }
  },
  computed: {
    getSort () {
      const applicantSort = this.$settings.get({ path: 'pages.applicantOffers.defaultSorters' })
      return this.payload.resource_type == 'Applicant' ? applicantSort : '-updated_at'
    },
    getDefaultStatuses () {
      return this.payload.resource_type == 'Applicant' ? 'awaiting_company,system_strong,awaiting_applicant_strong,awaiting_admin_intake' : 'awaiting_company,system_strong,awaiting_applicant_strong,awaiting_admin_intake,expired_before_sent'
    },
    getOffersLinkRouteName () {
      return this.payload.resource_type == 'Applicant' ? 'applicant-offers' : 'position-offers'
    },
    getOffersLinkQuery () {
      return this.payload.resource_type == 'Applicant' ? { applicant_id: this.payload.resource_id, m: 1 } : { position_id: this.payload.id, company_id: this.payload.company.resource_id, m: 'd' }
    },
    resource_id () {
      return this.payload.resource_id == undefined ? this.payload.id : this.payload.resource_id
    },
    mergedPayload () {
      return { ...this.payload, ...this.additional_data }
    },
    ...mapGetters('modals', ['findModal']),
    ...mapGetters('offerStatuses', ['getRedList', 'getDarkRedList', 'getPurpleList', 'getGreenList', 'getOrangeList'])
  },
  methods: {
    async ensureOfferStatusesLoaded () {
      // Check if offer statuses are already loaded
      if (this.$store.state.offerStatuses.offerStatusesList.length > 0) {
        return
      }

      // Wait for statuses to be fetched
      await this.$store.dispatch('offerStatuses/fetchOfferStatuses')
    },
    showCountOnly () {
      let requests = []
      requests.push(this.getResourceOffers({
        statuses: this.getStatusesByColor('Purple'),
        is_count_only: true
      }))
      requests.push(this.getResourceOffers({
        statuses: this.getStatusesByColor('Green'),
        is_count_only: true
      }))
      requests.push(this.getResourceOffers({
        statuses: this.getStatusesByColor('Orange'),
        is_count_only: true
      }))
      requests.push(this.getResourceOffers({
        statuses: this.getStatusesByColor('Red'),
        is_count_only: true
      }))
      requests.push(this.getResourceOffers({
        statuses: this.getStatusesByColor('DarkRed'),
        is_count_only: true
      }))
      requests.push(this.$network_utils.getCounters({
        sent_applicants: 'true',
        position_id: this.resource_id,
        user: '1'
      }))
      return new Promise((resolve, reject) => {
        this.$network_utils.caller.axios.all(requests).then(response => {
          this.purple_count_only = response[0]
          this.green_count_only = response[1]
          this.orange_count_only = response[2]
          this.red_count_only = response[3]
          this.dark_red_count_only = response[4]
          this.sendApplicantCounterOnly = response[5]
          resolve({
            purple: this.purple_count_only,
            green: this.green_count_only,
            orange: this.orange_count_only,
            red: this.red_count_only,
            dark_red: this.dark_red_count_only
          })
        })
      })
    },
    getModalTitle (color) {
      if (color == 'Red') {
        return 'Rejected Applicants - Not Sent'
      }
      if (color == 'DarkRed') {
        return 'Rejected Applicants - Sent But No Progress'
      }
      if (color == 'Orange') {
        return 'In Pending Applicants'
      }
      if (color == 'Purple') {
        return 'Awaiting Company Applicants'
      }
      return 'In Process Applicants'
    },
    onMouseOver (color) {
      let statuses = this.getStatusesByColor(color)
      if (color == 'Orange') {
        statuses = statuses.filter(s => s != 'awaiting_applicant')
      }
      this.create({
        designator: 'ghana-flag-modal',
        component_name: 'GhanaFlagForm',
        resource_type: this.mergedPayload.resource_type,
        resource_id: this.resource_id,
        resource_data: this.mergedPayload,
        color_group: color,
        statuses: statuses,
        modal_title: this.getModalTitle(color),
        modal_width: 1000
      })
    },
    getResourceOffers (params) {
      return this.$network_utils.getResourceOffers({
        resource_type: this.mergedPayload.resource_type,
        resource_id: this.resource_id,
        statuses: params.statuses,
        count_only: params.is_count_only
      })
    },
    getStatusesByColor (color) {
      return this['get' + color + 'List'].map(s => s.name)
    },
    onMouseLeave () {
      let modal = this.findModal({ type: 'designator', value: 'ghana-flag-modal' })
      this.remove(modal)
    },
    ...mapMutations('modals', ['create', 'remove'])
  }
}
</script>
